import { render } from "./OrderWaivers.vue?vue&type=template&id=20b41117"
import script from "./OrderWaivers.vue?vue&type=script&lang=js"
export * from "./OrderWaivers.vue?vue&type=script&lang=js"

import "./OrderWaivers.vue?vue&type=style&index=0&id=20b41117&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__